import type * as React from 'react';

type IconProps = React.SVGProps<SVGSVGElement> & { title?: string };

export const Save = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		type="submit"
		height="24px"
		viewBox="0 0 24 24"
		width="24px"
		fill="#000000"
		{...props}
	>
		<title>{props.title}</title>
		<path d="M0 0h24v24H0z" fill="none" />
		<path d="M19,3H5c-1.1,0-1.99,0.9-1.99,2L3,19c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V5C21,3.9,20.1,3,19,3z M12,19c-1.41,0-2.5-1.14-2.5-2.5S10.59,14,12,14s2.5,1.14,2.5,2.5S13.41,19,12,19z M17,9h-10V5h10V9z" />
	</svg>
);
